import styled from 'styled-components';
import { Link } from 'react-router-dom';

const LinkButton = ({ children, url }) => {
  return <StyledLink to={url}>{children}</StyledLink>;
};

const StyledLink = styled(Link)`
  position: fixed;
  left: 50%;
  bottom: -1rem;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 44rem;
  height: 7rem;
  background: var(--primary);
  font-family: var(--pretendard);
  font-size: 1.8rem;
  line-height: 2rem;
  font-weight: 500;
  text-align: center;
  border-radius: 3rem 3rem 0 0;
  box-shadow: 0px -4px 20px 0px rgba(0, 0, 0, 0.04);
  z-index: 999;
`;

export default LinkButton;
